import React from 'react';

const TabPanel = (props) => {
    let processStyle = props.style ? props.style : {};
    return <div className="tabPanel" style={Object.assign({},{height:"100%",maxHeight:"100%"},processStyle)}>
        {props.details?.content}</div>
};

export default TabPanel;
